import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CatalogPayableScheme, CatalogPayableSchemeInput} from './catalog-payable-scheme.model';

export const loadCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] Load CatalogPayableSchemes',
  props<{ catalogPayableSchemes: CatalogPayableScheme[] }>()
);

export const addCatalogPayableScheme = createAction(
  '[CatalogPayableScheme/API] Add CatalogPayableScheme',
  props<{ catalogPayableScheme: CatalogPayableScheme }>()
);

export const upsertCatalogPayableScheme = createAction(
  '[CatalogPayableScheme/API] Upsert CatalogPayableScheme',
  props<{ catalogPayableScheme: CatalogPayableScheme }>()
);

export const addCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] Add CatalogPayableSchemes',
  props<{ catalogPayableSchemes: CatalogPayableScheme[] }>()
);

export const upsertCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] Upsert CatalogPayableSchemes',
  props<{ catalogPayableSchemes: CatalogPayableScheme[] }>()
);

export const updateCatalogPayableScheme = createAction(
  '[CatalogPayableScheme/API] Update CatalogPayableScheme',
  props<{ catalogPayableScheme: Update<CatalogPayableScheme> }>()
);

export const updateCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] Update CatalogPayableSchemes',
  props<{ catalogPayableSchemes: Update<CatalogPayableScheme>[] }>()
);

export const deleteCatalogPayableScheme = createAction(
  '[CatalogPayableScheme/API] Delete CatalogPayableScheme',
  props<{ id: string }>()
);

export const deleteCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] Delete CatalogPayableSchemes',
  props<{ ids: string[] }>()
);

export const clearCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] Clear CatalogPayableSchemes'
);


// CUSTOM
export const createCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] create CatalogPayableSchemes',
  props<{ input: CatalogPayableSchemeInput }>()
);


export const editCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] edit CatalogPayableSchemes',
  props<{ input: CatalogPayableSchemeInput }>()
);


export const removeCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] remove CatalogPayableSchemes',
  props<{ itemUniqueId: string, id: string }>()
);


export const getCatalogPayableSchemes = createAction(
  '[CatalogPayableScheme/API] get all CatalogPayableSchemes',
  props<{ catalogyUniqueId: string }>()
);

export const citizenGetInstitutionServiceCatalogSchemes = createAction(
  '[CatalogPayableScheme/API] citizen get all CatalogPayableSchemes',
  props<{ catalogyUniqueId: string }>()
);

export const citizenGetInstitutionServiceCatalogItems = createAction(
  '[CatalogPayableScheme/API] citizen get institution Catalog Items',
  props<{ catalogyUniqueId: string }>()
);
